import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a481bec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PushProcessingList" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("签到领苗豆，每日签到可获得5-30苗豆，连续签到可获得更苗豆，苗豆可用于报价，充值，提现等。")
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "cornerMarker" }
const _hoisted_5 = { class: "titleWarpper" }
const _hoisted_6 = { class: "avatar" }
const _hoisted_7 = {
  class: "titlecontainer",
  style: {"flex":"1"}
}
const _hoisted_8 = { class: "title" }
const _hoisted_9 = {
  class: "tips",
  style: {"whiteSpace":"pre-line"}
}
const _hoisted_10 = { class: "profile" }
const _hoisted_11 = { class: "footer" }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("打电话")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_15 = { class: "telNum" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "jumpToRegister" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("我要赚更多的钱，点此修改订阅")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanSwipeItem = _resolveComponent("VanSwipeItem")!
  const _component_VanSwipe = _resolveComponent("VanSwipe")!
  const _component_VanNoticeBar = _resolveComponent("VanNoticeBar")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanPopup = _resolveComponent("VanPopup")!
  const _component_RestrictDialog = _resolveComponent("RestrictDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanSwipe, {
      autoplay: 3000,
      "indicator-color": "white"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.images, (image) => {
          return (_openBlock(), _createBlock(_component_VanSwipeItem, {
            class: "my-swipe",
            key: image
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VanImage, {
                src: image.imageUrl,
                alt: "图片",
                width: "100%",
                height: "100%",
                onClick: ($event: any) => ($setup.junmp(image.linkUrl))
              }, null, 8, ["src", "onClick"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    ($setup.showCheckIn)
      ? (_openBlock(), _createBlock(_component_VanNoticeBar, {
          key: 0,
          mode: "link",
          color: "#1989fa",
          background: "#ecf9ff",
          "left-icon": "info-o",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name:"CheckIn"})))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_VanList, { class: "list" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "listItem",
            key: `item${idx}`,
            onClick: ($event: any) => ($setup.router.push({name:"PushProcessingDetail",query:{id:item.purchaseId_Str}}))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_VanImage, {
                src: require("@/assets/img/jiaobiao.png")
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_VanImage, {
                  src: item.avatars?`https://img.miaodadang.com/${item.avatars}`:`https://img.miaodadang.com/avatars/default_head.png?id=1647401090026`,
                  alt: "图片",
                  width: "3rem",
                  height: "3rem",
                  round: ""
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(item.areaName), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.profile), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString($setup.moment(item.createTime).fromNow()), 1),
              _createVNode(_component_VanButton, {
                size: "small",
                color: "red",
                round: "",
                onClick: _withModifiers(($event: any) => ($setup.getTell(item.purchaseId_Str)), ["stop"])
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ], 8, _hoisted_3))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_VanPopup, {
      class: "callDialog",
      show: $setup.isShowTel,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (($setup.isShowTel) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, "是否拨打 " + _toDisplayString($setup.tel), 1),
        _createElementVNode("a", {
          class: "call",
          href: `tel:${$setup.tel}`
        }, "立即呼叫", 8, _hoisted_16)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_RestrictDialog, {
      modelValue: $setup.restrictShow,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.restrictShow) = $event)),
      code: $setup.restrictCode,
      type: "single"
    }, null, 8, ["modelValue", "code"]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_VanButton, {
        color: "#19be6b",
        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.router.push("Register"))),
        block: ""
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      })
    ])
  ]))
}